import React from 'react';
import Header from 'components/Header';
import Footer from 'components/Footer';
import { Container } from 'components/Container';
import Helmet from 'components/Helmet';

import Cookies from './Cookies';
import { StyledCookieDeclaration } from './styles';

class CookieDeclaration extends React.Component {
  showConsents = () => {
    window.ICC.helpers.togglePopup();
  }
  render() {
    return (
      <StyledCookieDeclaration>
        <Helmet title="Cookie Declaration" />
        <Header rsvp={false} />
        <Container>
          <div className="content">
            <h1>Cookie Declaration</h1>
            <p>This website uses cookies. We use cookies to provide a consistent experience across our site, preserve preferences, provide important analytics, and to share useful data with marketing/analytics partners we use so that we may later personalise content/ads. All data is anonymized where possible.</p>
            <p>Cookies are small text files that can be used by websites to make a user&apos;s experience more efficient.</p>
            <p>The law states that we can store cookies on your device if they are strictly necessary for the operation of this site. For all other types of cookies we need your permission.</p>
            <p>This site uses different types of cookies. Some cookies are placed by third party services that appear on our pages.</p>
            <p>You can at any time <button onClick={this.showConsents}>change or withdraw your consent</button> from the Cookie Declaration on our website.</p>
            <p>Learn more about who we are, how you can contact us and how we process personal data in our Privacy Policy.</p>
            <p>Your consent applies to the following domains: <strong>affiliateafterhours.com</strong></p>
          </div>
          <Cookies />
        </Container>
        <Footer />
      </StyledCookieDeclaration>
    );
  }
}

export default CookieDeclaration;



// WEBPACK FOOTER //
// ./src/containers/CookieDeclaration/index.js